module.exports = __webpack_public_path__ + "static/media/user.28bd5250.svg";